import apiHandler from '../core/apiHandler';

/**
 * API base del Evento de Retorno de compras (Sujeto Excluido).
 *
 * Backend:
 * /api/dte/purchases/return
 */
const purchaseReturnApi = apiHandler('dte/purchases/return');

export default purchaseReturnApi;
